import { Component } from 'react';

import CustomLinkButton from "GeneralComponents/CustomLinkButton";
import CarouselItem from "../Carousel.interface"
import LimitedContent from "GeneralComponents/LimitedContent";

import "./FlippingItems.css";
import Consts from 'Interfaces/Consts';
import Helper from 'Interfaces/Helper';



export default class FlippingCarouselItem extends Component {

    props: any;

    state:
        {
            carouselItem: CarouselItem;
            isflip: boolean;
            flipAll: boolean;
            componentTitle: string;
            isLoading: boolean;
        }



    constructor(props) {
        super(props);

        this.state = {
            carouselItem: this.props.carouselItem,
            isflip: false,
            flipAll: this.props.isFlipAll,
            componentTitle: this.props.title,
            isLoading: false
        };

        this.flipCard = this.flipCard.bind(this);

    }


    flipCard = () =>
    {
        if (!this.state.isflip)
        { 
            Helper.handleLinkClicksGA4("Flippings", this.state.componentTitle, this.state.carouselItem.title)
        }

        this.setState({ isflip: !this.state.isflip,isLoading:true });
        this.props.setFlipAll(false);

        setTimeout(() => {
            this.setState({ isLoading:false })
        },900)
    }





    render() {

        if (this.props.isflipAll) {
            this.state.isflip = false;
        }

        let linkIconType = this.props.dir == 'rtl' ? "fa-chevron-left" : "fa-chevron-right";


        return (

            <div className={`item mst-carousel-item d-flex overflow-hidden  flip-box   ${this.state.isflip ? 'back' : 'front'} ${this.state.isflip ? 'flipCard' : ''}`} >

                <div className="mst-card mst-box-item d-flex flex-column align-items-center  justify-content-center  flip-box-inner" >
                    {(!this.state.isflip || this.state.isLoading) && < div className="flip-box-front">
                        <div className="mb-3 flip-box-icon p-auto">
                            <i className={(this.state.carouselItem.icon) + ' minisite-font-36 pallete-color '}></i>
                        </div>
                        <div className="text-center">
                            <div className="mst-card-content content-txt  ">

                                <h3 className="primary-palette-color mb-2">{this.state.carouselItem.title}</h3>

                                {!this.state.carouselItem.richDescription ?
                                    (<LimitedContent htmlContent={this.state.carouselItem.content} classNames="flip-box-content"></LimitedContent>)
                                    :
                                    (<LimitedContent htmlContent={this.state.carouselItem.richDescription} classNames="flip-box-content"></LimitedContent>)
                                }

                            </div>
                        </div>
                        <div className={`${this.state.carouselItem.url || this.state.carouselItem.link.url || this.state.carouselItem.content ? "align-bottom" :""}`} >

                            {(this.state.carouselItem.url || this.state.carouselItem.link.url) ?
                                (<CustomLinkButton
                                    title={this.state.carouselItem.title}
                                    pageUrl={this.state.carouselItem.url}
                                    link={this.state.carouselItem.link}
                                    isBtn={false}
                                    btnClass={"btn btn-outline-primary mst-btn mst-btn-round px-auto"}
                                    linkClass={"mst-extra-link"}
                                    dir={this.props.dir}
                                    linkIcon={true}
                                    charLimit={30}/>)
                                :
                                (
                                    (this.state.carouselItem.content) &&
                                    <span className="flip-link"
                                        tabIndex={0}
                                        aria-pressed={this.state.isflip ? true : false}
                                        onClick={this.flipCard}
                                        onKeyPress={this.flipCard}
                                        role="button"
                                        aria-label={` ${Consts.moreInfoAbout} ${this.state.carouselItem.title ? this.state.carouselItem.title : this.state.carouselItem.richDescription.slice(3, 50)}`}>  {Consts.moreInfo} <i className={"fa fa-fw " + (linkIconType)} aria-hidden="true"></i></span>)
                            }
                        </div>
                    </div>}
                    {(this.state.isflip || this.state.isLoading) && < div className="flip-box-back">
                        <div className="mb-3 flip-box-icon p-auto">
                            <i className={(this.state.carouselItem.icon) + ' minisite-font-36 pallete-color '}></i>
                        </div>
                        <div className="text-center">
                            <div className="mst-card-content px-3 content-txt  ">

                                <h3 className="primary-palette-color mb-2">{this.state.carouselItem.title}</h3>

                                <LimitedContent htmlContent={this.state.carouselItem.content} classNames="flip-box-content"></LimitedContent>



                            </div>
                        </div>
                        <div className="align-bottom " >
                            <span className="flip-link" tabIndex={this.state.isflip ? 0 : -1} aria-pressed={this.state.isflip ? true : false} onClick={this.flipCard} onKeyPress={this.flipCard} role="button" aria-label={` ${Consts.close} `}>  {Consts.close} </span>

                        </div>
                    </div>}

                </div>

            </div>






        );
    }



}
